import { rejectHardCopy, resolveHardCopy } from '../components/RejectHardCopy/private/fields';

export default Object.freeze({
  [resolveHardCopy]: {
    title: 'Уведомление о необходимости получения документов на бумажном носителе',
    actionType: resolveHardCopy,
  },
  [rejectHardCopy]: {
    title: 'Уведомление об отказе получения документов на бумажном носителе',
    actionType: rejectHardCopy,
  },
});
